import React from "react";
import { getTeamLogo } from "@/lib/teamLogos";

export default function TeamLogo({
  teamName,
  alt,
  size = 32,
  className = "",
  fallback = null,
}) {
  const logo = getTeamLogo(teamName);

  if (!logo) {
    return fallback;
  }

  return (
    <img
      src={logo}
      alt={alt || `${teamName || "Lag"} logotyp`}
      width={size}
      height={size}
      className={className}
      loading="lazy"
      decoding="async"
    />
  );
}
